// extracted by mini-css-extract-plugin
module.exports = {"jobTitle":"JobItem_jobTitle__OTlxQ","jobDate":"JobItem_jobDate__2KRgw"};